'use client';

import { useAtomValue } from 'jotai';

import type { GenericVehicleListingSubset } from '@core/Actions/Vehicle/ExtractGenericVehicleListingSubset.action';
import type { SearchParamsType } from '@core/Atoms/SearchParams/SearchParams.atom';
import { experimentsAtom } from '@growthBookExperimentation/Atoms/Experiments.atom';
import { TrackPage } from '@tracking/Components/ClientWrappers/TrackPage';
import type { VehicleDetailsSubset } from '@tracking/Schemas/VehicleDetails/ExtractVehicleDetailsSubset';

import { hasMountedOnPdpAtom } from 'Atoms/App/Pdp/hasMountedOnPdp.atom';
import { TrackCustomPageEvent } from 'Components/ClientWrappers/TrackCustomPageEvent';

import { generatePdpTrackingData } from '../GeneratePdpEvents.tracking';

interface TrackPdpEventsProps {
  genericVehicleListings: GenericVehicleListingSubset;
  vehicleDetailsSubset: VehicleDetailsSubset;
  vehicleId: string;
  searchParams: SearchParamsType;
  hasReviewData: boolean;
  hasGuaranteeData: boolean;
}

export const TrackPdpEvents: React.FC<TrackPdpEventsProps> = ({
  genericVehicleListings,
  vehicleDetailsSubset,
  vehicleId,
  searchParams,
  hasReviewData,
  hasGuaranteeData,
}) => {
  const experiments = useAtomValue(experimentsAtom);
  const isFirstVisitedPdp = useAtomValue(hasMountedOnPdpAtom);

  const {
    pdpEvents: { event, context, customPageEventContext },
  } = generatePdpTrackingData(
    genericVehicleListings,
    vehicleDetailsSubset,
    vehicleId,
    hasGuaranteeData,
    hasReviewData,
    experiments,
    isFirstVisitedPdp,
  );

  return (
    <>
      <TrackPage context={context} searchParams={searchParams} />
      <TrackCustomPageEvent event={event} context={customPageEventContext} />
    </>
  );
};
